import Vue from 'vue';
import Vuex from 'vuex';

// Core store
import state from "./core/state";
import getters from "./core/getters";
import mutations from "./core/mutations";
import actions from "./core/actions";

// Development tool store
import Dev from "../store/dev-tool";

// Required Modules
// Should not import any non require modules here to reduce bundle size and first byte loading time.
import theme from "../store/modules/theme";
import User from "./modules/user";
import Student from "../store/modules/student";
import StudentUnitTest from "../store/modules/student-unittest";
import StudentUnitLearn from "../store/modules/student-unit-learn";
import StudentEnroll from "../store/modules/student-enroll";
import Examination from "../store/modules/examination";
import Classroom from "../store/modules/classroom";
import LiveClass from "../store/modules/liveclass";
import StudentAssignment from "../store/modules/student-assignment";
import CourseFaq from "../store/modules/course-faq";
import WebBoard from "../store/modules/web-board";
import WebBoardReply from "../store/modules/web-board-reply";
import PrivateMessage from "../store/modules/private-message";
import PrivateMessageReply from "../store/modules/private-message-reply";
import ClassSection from "../store/modules/course/class-section";
import StudentEnrollDetail from "../store/modules/student-enroll/student-enroll-detail";
import StudentScore from "../store/modules/student-score";
import CourseOutlineRegistration from "../store/modules/course/course-outline-registration";
import Notification from "../store/modules/notification";
import AcademicPeriodConfig from '../store/modules/common-data/academic-period-config/index';
import AdvisorOnlineSchedule from '../store/modules/advisor-online-schedule/index';
import InfoGroup from '../store/modules/university-news/info-group/index';
import InfoTopic from '../store/modules/university-news/info-topic/index';
import SystemConfig from '@/store/modules/system/system-config/index';

import Chat from "../store/modules/chat";

Vue.use(Vuex);

// Strict mode
const strict = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  strict,

  // Core
  state,
  getters,
  actions,
  mutations,

  // Modules
  modules: {
    Dev,
    theme,
    Student,
    StudentUnitTest,
    User,
    Examination,
    Classroom,
    LiveClass,
    StudentAssignment,
    CourseFaq,
    WebBoard,
    WebBoardReply,
    StudentUnitLearn,
    PrivateMessage,
    PrivateMessageReply,
    ClassSection,
    StudentEnrollDetail,
    StudentScore,
    CourseOutlineRegistration,
    Notification,
    AcademicPeriodConfig,
    Chat,
    StudentEnroll,
    AdvisorOnlineSchedule,
    InfoGroup,
    InfoTopic,
    SystemConfig,
  },
});
